<template>
  <iframe
    class="link-frame"
    :class="{'link-frame--partial': partial}"
    v-if="src"
    :src="src"
    allowfullscreen="false"
    allow="camera; microphone"
  />
</template>

<script>
export default {
  computed: {
    src: vm => vm.$store.getters['linkFrame/current']
  },
  props: {
    partial: Boolean
  }
};
</script>

<style lang="scss" scoped>
.link-frame {
  position: relative;
  z-index: 999;
  width: 100%;
  height:100%;
  border: 0;
  outline: 0;
  background: white;

  &--partial {
    width: 80%;
    min-width: 80%;
  }
}
</style>
